module.exports = global["_"] = require("-!./underscore.js");


/*****************
 ** WEBPACK FOOTER
 ** ../~/expose-loader?_!../~/underscore/underscore.js-exposed
 ** module id = 382
 ** module chunks = 10
 **/